import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function usePublicSettings() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setS(r.data)).catch(() => setS({}));
  }, []);
  return s;
}
